<template>
  <div id="app">
    <div v-if="$route.name === 'detailsDown'" >
      <router-view />
    </div>
    <div v-else>
      <Title v-if="titleIsShow"></Title>
      <router-view />
      <RightZX v-if="titleIsShow"></RightZX>
      <Footer></Footer>
    </div>
   
  </div>
</template>
<script>
import Title from "./views/more/title.vue"
import Footer from "./views/more/footer.vue"
import RightZX from "./views/more/rightZX.vue"

export default {
  name: 'App',
  components: { Title, Footer, RightZX },
  data () {
    return {
      titleIsShow: false,
    }
  },
  watch: {
    $route (to) {
      if (to.name !== 'System') { this.titleIsShow = true }
    }
  },
  mounted() {
    console.log(';111')
    console.log(this.$route.name === 'detailsDown')
  }

}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
